import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { dateFormat } from "../tools";
import moment from "moment";

export const handlePrintBoardToPDF = async ({ id, title }) => {
  // display the clientHeader: client alias and timestamp of the print
  const headerElement = document.getElementById("pdfMoodboardHeader");
  const canvasHeader = await html2canvas(headerElement, {
    background: "#f5f5f5f5",
    scale: 2,
    windowWidth: 1920,
  });
  const imgDataHeader = canvasHeader.toDataURL("image/png");

  // display the moodboards (1 boards)
  const moodboardElement = document.getElementById(`board-${id}`);
  const canvasMoodboards = await html2canvas(moodboardElement, {
    background: "#f5f5f5f5",
    scale: 2,
    windowWidth: 1920,
  });
  const imgDataMoodboards = canvasMoodboards.toDataURL("image/png");

  // create the PDF
  const pdf = new jsPDF();
  const margin = 5;
  const imgWidth = 190 + margin; // width of the image in the pdf

  const imgHeightMoodboards =
    (canvasMoodboards.height * imgWidth) / canvasMoodboards.width;
  const imgHeightHeader = (canvasHeader.height * imgWidth) / canvasHeader.width;

  let position = 28;

  pdf.addImage(imgDataHeader, "PNG", 10, 10, imgWidth, imgHeightHeader);
  pdf.addImage(
    imgDataMoodboards,
    "PNG",
    margin,
    position,
    imgWidth,
    imgHeightMoodboards
  );

  pdf.save(`m-Path - ${title} - ${moment().format(dateFormat)}.pdf`);
};

/* 
export const handlePrintMoodboardsToPDF = async () => {
  // display the clientHeader: client alias and timestamp of the print
  const headerElement = document.getElementById("pdfMoodboardHeader");
  const canvasHeader = await html2canvas(headerElement, {
    background: "#f5f5f5f5",
    scale: 2,
    windowWidth: 1920,
  });
  const imgDataHeader = canvasHeader.toDataURL("image/png");

  // display the moodboards (all boards)
  const moodboardsElement = document.getElementById("pdf-content");
  const canvasMoodboards = await html2canvas(moodboardsElement, {
    background: "#f5f5f5f5",
    scale: 2,
    windowWidth: 1920,
  });
  const imgDataMoodboards = canvasMoodboards.toDataURL("image/png");

  // create the PDF
  const pdf = new jsPDF();
  const margin = 5;
  const imgWidth = 190 + margin; // width of the image in the pdf
  const pageHeight = 269;

  const imgHeightMoodboards =
    (canvasMoodboards.height * imgWidth) / canvasMoodboards.width;
  const imgHeightHeader = (canvasHeader.height * imgWidth) / canvasHeader.width;

  let heightLeft = imgHeightMoodboards;
  let position = 28;

  pdf.addImage(imgDataHeader, "PNG", 10, 10, imgWidth, imgHeightHeader);
  pdf.addImage(
    imgDataMoodboards,
    "PNG",
    margin,
    position,
    imgWidth,
    imgHeightMoodboards
  );
  heightLeft -= pageHeight;

  // Add pages when there is still content to render
  while (heightLeft >= 0) {
    position = heightLeft - imgHeightMoodboards;
    pdf.addPage();
    pdf.addImage(
      imgDataMoodboards,
      "PNG",
      margin,
      position,
      imgWidth,
      imgHeightMoodboards
    );
    heightLeft -= pageHeight;
  }

  pdf.save(`m-Path - ${moment().format(dateFormat)}.pdf`);
}; */

export const handlePrintMoodboardsToPDF = async () => {
  const pdf = new jsPDF("p", "mm", "a4"); // A4 in portrait mode
  const pageWidth = pdf.internal.pageSize.getWidth(); // 210mm
  const pageHeight = pdf.internal.pageSize.getHeight(); // 297mm
  const margin = 10; // Marges rondom de content

  // HEADER ophalen en renderen
  const headerElement = document.getElementById("pdfMoodboardHeader");
  const canvasHeader = await html2canvas(headerElement, { scale: 2 });
  const imgDataHeader = canvasHeader.toDataURL("image/png");
  const imgWidth = pageWidth - 2 * margin; // Houd rekening met marges
  const imgHeightHeader = (canvasHeader.height * imgWidth) / canvasHeader.width;

  pdf.addImage(imgDataHeader, "PNG", margin, margin, imgWidth, imgHeightHeader);
  let yPosition = margin + imgHeightHeader + 5; // Startpositie voor de moodboards

  // MOODBOARDS ophalen en renderen in stukken
  const moodboardsElement = document.getElementById("pdf-content");
  const canvasMoodboards = await html2canvas(moodboardsElement, { scale: 2 });
  const imgDataMoodboards = canvasMoodboards.toDataURL("image/png");
  const imgHeightMoodboards =
    (canvasMoodboards.height * imgWidth) / canvasMoodboards.width;

  let heightLeft = imgHeightMoodboards;
  let position = 0;

  while (heightLeft > 0) {
    const sliceHeight = Math.min(pageHeight - yPosition - margin, heightLeft);
    
    // Snij een stuk uit de afbeelding
    const croppedCanvas = document.createElement("canvas");
    const ctx = croppedCanvas.getContext("2d");
    croppedCanvas.width = canvasMoodboards.width;
    croppedCanvas.height = (sliceHeight * canvasMoodboards.width) / imgWidth;

    ctx.drawImage(
      canvasMoodboards,
      0,
      position,
      canvasMoodboards.width,
      croppedCanvas.height,
      0,
      0,
      croppedCanvas.width,
      croppedCanvas.height
    );

    const imgDataCropped = croppedCanvas.toDataURL("image/png");

    pdf.addImage(imgDataCropped, "PNG", margin, yPosition, imgWidth, sliceHeight);

    heightLeft -= sliceHeight;
    position += croppedCanvas.height;
    yPosition = margin; // Reset positie voor volgende pagina

    if (heightLeft > 0) {
      pdf.addPage();
    }
  }

  pdf.save(`m-Path - ${moment().format("YYYY-MM-DD")}.pdf`);
};

